var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.modalComments
        ? _c("customModal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.modalComments,
                expression: "modalComments",
              },
            ],
            attrs: {
              onModalClose: _vm.onModalClose,
              onModalAccept: _vm.saveComment,
              modalData: _vm.modalComments,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (slotProps) {
                    return _c("div", {}, [
                      _vm.modalComments.detail.comments &&
                      _vm.modalComments.detail.comments.length
                        ? _c(
                            "div",
                            _vm._l(
                              _vm.modalComments.detail.comments,
                              function (comment) {
                                return _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-left modal_comment_block",
                                  },
                                  [
                                    _c("p", [_vm._v(_vm._s(comment.text))]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "text-muted" }, [
                                      _vm._v(
                                        _vm._s(comment.user_name) +
                                          " (" +
                                          _vm._s(_vm.printDate(comment.date)) +
                                          ")"
                                      ),
                                    ]),
                                  ]
                                )
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c("div", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.modalComments.new_comment,
                              expression: "modalComments.new_comment",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            placeholder: "Ваш комментарий",
                          },
                          domProps: { value: _vm.modalComments.new_comment },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.modalComments,
                                "new_comment",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ])
                  },
                },
              ],
              null,
              false,
              577555747
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-default comments_btn",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.openCommentBlock(_vm.detail)
            },
          },
        },
        [
          _c("i", { staticClass: "icon-fa icon-fa-comments-o text-center" }),
          _vm._v(" "),
          _vm.detail.comments && _vm.detail.comments.length
            ? _c("span", { staticClass: "badge badge-info" }, [
                _vm._v(_vm._s(_vm.detail.comments.length)),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }